import type { ChannelPerson } from '@/lib/channelPerson';
import type { ReplyTemplate, ReplyVariable } from '@/lib/replyTemplates';
import { DEMO_AUTHOR, ENTITIES } from './model';
const now = Date.now();
const handles = ['anna-demo', 'mira-demo', 'elena-demo', 'danil-demo'];
export const PEOPLE: ChannelPerson[] = [
  ...ENTITIES.filter((entity) => entity.kind === 'user').map((person, index): ChannelPerson => ({
    ...person,
    accounts: [
      { id: person.id + '-mail', channel: 'Почта', address: handles[index] + '@example.test' },
      { id: person.id + '-chat', channel: 'Мессенджер', address: '@' + handles[index] },
    ],
    timeZone: ['Europe/Moscow', 'Europe/Berlin', 'Asia/Tokyo', 'UTC'][index],
    duty: {
      state: index % 2 === 0 ? 'on' : 'off',
      checkedAt: new Date(now - 5 * 60_000).toISOString(),
      expiresAt: new Date(now + (index === 3 ? -60_000 : 86_400_000)).toISOString(),
    },
  })),
  { ...DEMO_AUTHOR, accounts: [] },
];
export const REPLY_TEMPLATES: ReplyTemplate[] = [
  {
    id: 'received',
    title: 'Сообщение получено',
    body: 'Здравствуйте, {{first_name}}!\n\nПолучили сообщение по теме «{{subject}}». Вернёмся с ответом {{reply_by}}.\n\n{{signature}}',
  },
  {
    id: 'details',
    title: 'Уточнить детали',
    body: 'Здравствуйте, {{first_name}}!\n\nПо теме «{{subject}}» нужно уточнить: {{details}}.\n\n{{signature}}',
  },
  {
    id: 'complete',
    title: 'Вопрос решён',
    body: '{{first_name}}, всё готово ✅\n\nПроверьте, пожалуйста, результат по теме «{{subject}}».\n\n{{signature}}',
  },
];
export function replyVariables(name = 'Анна', subject = 'Общий макет'): ReplyVariable[] {
  return [
    { key: 'first_name', label: 'Имя получателя', value: name },
    { key: 'subject', label: 'Тема', value: subject },
    { key: 'reply_by', label: 'Когда ответим', value: 'завтра до 12:00 МСК' },
    { key: 'details', label: 'Что уточнить', value: '' },
    { key: 'signature', label: 'Подпись', value: 'Команда образца' },
  ];
}
